export { default } from './ErrorNotFound';
